import React from 'react'
import logo from '../../../resources/logo_50x50.png'
import { SIDEBAR_BOTTOM_LINKS, SIDEBAR_LINKS } from '../../navigation'
import { NavLink } from 'react-router-dom'
import { FiGithub, FiExternalLink } from 'react-icons/fi'

const REPOSITORY_URL = 'https://github.com/BraisIglesias17/NeuroRules.git'

export default function Sidebar() {
  return (
    <aside className="sidebar" aria-label="Main navigation">
      <NavLink to="/" className="brand" aria-label="Neurorule home">
        <span className="brand-mark"><img src={logo} alt="" /></span>
        <span className="brand-name">Neuro<span>rule</span></span>
      </NavLink>
      <nav className="nav-links">
        {SIDEBAR_LINKS.map((item) => <SidebarLink key={item.key} item={item} />)}
      </nav>
      <div className="sidebar-footer">
        <a className="repository-link" href={REPOSITORY_URL} target="_blank" rel="noopener noreferrer">
          <FiGithub aria-hidden="true" /><span>Open source</span><FiExternalLink className="external-icon" aria-hidden="true" />
        </a>
        {SIDEBAR_BOTTOM_LINKS.map((item) => <SidebarLink key={item.key} item={item} />)}
      </div>
    </aside>
  )
}

function SidebarLink({ item }) {
  if (item.external) {
    return (
      <a href={item.path} className="nav-link" target="_blank" rel="noopener noreferrer">
        <span className="nav-icon" aria-hidden="true">{item.icon}</span><span>{item.label}</span>
        <FiExternalLink className="external-icon" aria-hidden="true" />
      </a>
    )
  }

  return (
    <NavLink to={item.path} end={item.path === '/'} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <span className="nav-icon" aria-hidden="true">{item.icon}</span><span>{item.label}</span>
    </NavLink>
  )
}
